module.exports = __webpack_public_path__ + "img/stephenshaw.249520d1.png";